module.exports = __webpack_public_path__ + "img/FQSP03.6a7fbfe7.svg";